

function Terms() {
  return (
    <div className="bg-gray-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-md p-8">
        <h1 className="text-3xl font-bold mb-6 text-indigo-700">Terms & Conditions</h1>

        <section className="space-y-6 text-gray-700 leading-relaxed">
          <p>
            It is a long established fact that a reader will be distracted by the readable content
            of a page when looking at its layout. The point of using Lorem Ipsum is that it has a
            more-or-less normal distribution of letters, as opposed to using 'Content here, content
            here', making it look like readable English.
          </p>
          <p>
            Many desktop publishing packages and web page editors now use Lorem Ipsum as their
            default model text, and a search for 'lorem ipsum' will uncover many web sites still in
            their infancy. Various versions have evolved over the years, sometimes by accident,
            sometimes on purpose injected humour and the like.
          </p>

          <h2 className="text-xl font-semibold mt-8 text-gray-900">Where does it come from?</h2>
          <p>
            Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a
            piece of classical Latin literature from 45 BC, making it over 2000 years old.
          </p>
          <p>
            Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit
            laboriosam, nisi ut aliquid ex ea commodi consequatur. Quis autem vel eum iure
            reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur.
          </p>

          <ul className="list-disc ml-6 space-y-2">
            <li>Et harum quidem rerum facilis est et expedita distinctio.</li>
            <li>
              Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe
              eveniet.
            </li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 text-gray-900">Why do we use it?</h2>
          <p>
            All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as
            necessary, making this the first true generator on the Internet.
          </p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
            exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </p>
          <p>
            No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because
            those who do not know how to pursue pleasure rationally encounter consequences that are
            extremely painful.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Terms;
